import type { ReactNode } from 'react';
import { Skeleton } from '../../../shared/components/Skeleton';
import { SkeletonFields } from '../../../shared/components/SkeletonFields';
import { SkeletonRegion } from '../../../shared/components/SkeletonRegion';
import { COMPANY_PAGE_GRID } from '../policies/company-page-layout';

function CardSkeleton({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-lg border border-line bg-surface p-6">
      <div className="mb-6 flex items-center gap-3">
        <Skeleton className="size-9 rounded-lg" />
        <Skeleton className="h-5 w-44 max-w-full" />
      </div>
      {children}
    </div>
  );
}

/** The company page before its settings arrive, in the form's own two columns so nothing shifts when they do. */
export function CompanyPageSkeleton() {
  return (
    <SkeletonRegion label="Loading company settings" className={COMPANY_PAGE_GRID}>
      <div className="flex flex-col gap-6">
        <CardSkeleton>
          <SkeletonFields count={4} />
        </CardSkeleton>
        <CardSkeleton>
          <SkeletonFields count={2} />
        </CardSkeleton>
      </div>
      <div className="flex flex-col gap-6">
        <CardSkeleton>
          <Skeleton className="h-8 w-full" />
          <Skeleton className="mt-3 h-56 w-full rounded-lg" />
        </CardSkeleton>
        <CardSkeleton>
          <SkeletonFields count={2} />
        </CardSkeleton>
      </div>
    </SkeletonRegion>
  );
}
